import store from "@/state/store"
import { exigePlanoComunicacao } from "@/utils/plano-comunicacao"
import { exibeSugestoesConteudo } from "@/utils/sugestoes-conteudo"
import { isStripeBilling, openBillingPortal } from "@/utils/billing-provider"
import i18n from '@/i18n/i18n'

const Roles = {
    //Sistemicas/temporarias
    AllLoggedUsers: "allLoggedUsers",
    IsMention: "uM",
    IsCliente: "uC",

    AcceptTerms: "acceptTerms",
    FillClientData: "fillClientData",
    ResponderPesquisa: "pesquisa",
    // Computed at login: active clipping customer with RelatorioPublicacoes (118)
    AddOwnPublications: "addOwnPublications",

    // Clientes
    LerMeusPedidos: "100",
    RevisarMeusPedidos: "101",
    CriarMeusPedidos: "102",
    ComentarMeusPedidos: "103",
    ExcluirMeusPedidos: "104",
    GerenciarArquivosMeusPedidos: "105",
    CompartilharMeusPedidos: "106",
    LerMinhasSugestoes: "107",
    AvaliarMinhasSugestoes: "108",
    LerMinhaEmpresa: "109",
    EditarMinhaEmpresa: "110",
    LerMeuPlanoComunicacao: "111",
    RevisarMeuPlanoComunicacao: "112",
    ComentarMeuPlanoComunicacao: "113",
    CompartilharMeuPlanoComunicacao: "114",
    LerMeusUsuarios: "115",
    AdicionarMeusUsuarios: "116",
    EditarMeusUsuarios: "117",
    RelatorioPublicacoes: "118",
    LerMeusResultados: "119",
    LerMinhasIndicacoes: "120",
    RelatorioResultados: "121",
    ReadCustomerInterview: "130",
    // Google Calendar meetings (banner, upgrade). Clipping customers do not have it
    ManageGoogleCalendar: "132",


    // Mention
    LerTodosPedidos: "500",
    ProducaoTodosPedidos: "501",
    RevisaoTodosPedidos: "502",
    ComentarTodosPedidos: "503",
    ExcluirTodosPedidos: "504",
    LerClientesPedidos: "505",
    ProducaoClientesPedidos: "506",
    RevisaoClientesPedidos: "507",
    ComentarClientesPedidos: "508",
    ExcluirClientesPedidos: "509",
    LerTodosPlanosComunicacao: "510",
    ProducaoTodosPlanosComunicacao: "511",
    RevisaoTodosPlanosComunicacao: "512",
    ComentarTodosPlanosComunicacao: "513",
    LerClientesPlanosComunicacao: "514",
    ProducaoClientesPlanosComunicacao: "515",
    RevisaoClientesPlanosComunicacao: "516",
    ComentarClientesPlanosComunicacao: "517",
    LerTodosClientes: "518",
    AdicionarClientes: "519",
    EditarFinanceiroTodosClientes: "520",
    EditarTodosClientes: "521",
    AtendimentoTodosClientes: "522",
    LerMeusClientes: "523",
    EditarMeusClientes: "524",
    AtendimentoMeusClientes: "525",
    LerTodosSugestoesConteudo: "526",
    CriarTodosSugestoesConteudo: "527",
    ExcluirTodosSugestoesConteudo: "528",
    LerClientesSugestoesConteudo: "529",
    CriarClientesSugestoesConteudo: "530",
    ExcluirClientesSugestoesConteudo: "531",
    RelatorioTodosPublicacoes: "532",
    RelatorioClientesPublicacoes: "533",
    RelatorioTodosPedidos: "534",
    RelatorioEngajamento: "535",
    RelatorioClientesPedidos: "536",
    RelatorioOpsCs: "549",
    RelatorioPlanoAcao: "552",
    TermosUso: "537",
    TermosUsoGerenciar: "538",
    Segmentos: "539",
    SegmentosGerenciar: "540",
    TemplateEmails: "541",
    TemplateEmailsGerenciar: "542",
    LerUsuarios: "543",
    CriarUsuarios: "544",
    EditarUsuarios: "545",
    AlterarSenhaUsuarios: "546",
    FazerPedidoTodos: "547",
    FazerPedidoClientes: "548",
    VisualizarLinks:"550",
    EditarLinks: "551",

    EnvioEmails: "553",
    AcessarCalendarioFeriados: "555",
    ExcluirLinks: "556",
    // 557 (Veiculos) is no longer used by the frontend: viewing the /veiculos page and its
    // menu entry now require VeiculosGerenciar (558). Kept here to document the backend id.
    Veiculos: "557",
    VeiculosGerenciar: "558",
    RelatorioTodasReunioes: "559",
    RelatorioClientesReunioes: "560",
    GerenciarArquivosFineTuning: "561",
    Clipping: "563",
    ReadPayments: "566",
    ReadResultsReport: "567",
    SolicitarDescarteAtendimento: "583",
    AprovarDescarteAtendimento: "584",
    SourceSegments: "579",
    SourceSegmentsManage: "580",

    // Comercial (600–609). Módulo com range próprio (backend #1653). Só a role
    // Administrador recebe estas permissões — Redator/Revisor não têm o módulo.
    // 600 é o umbrella (nenhum endpoint verifica; o front usa pra montar o menu),
    // as finas protegem cada recurso.
    // Substituíram: 554 (ComercialFormularioContatos), 562 (Indicacoes),
    // 581 (ReadSelfServiceLeads) e 582 (ManageSelfServiceLeads) — abandonadas.
    CommercialModuleAccess: "600",
    CommercialContactForm: "601",
    CommercialReferrals: "602",
    CommercialProspectClipping: "603",
    CommercialSelfServiceLeads: "604",
    CommercialPreRegistration: "605",
};

export const RolesDisplayRelatorios = [
    Roles.LerTodosClientes,
    Roles.RelatorioTodosPublicacoes, Roles.RelatorioClientesPublicacoes, 
    Roles.RelatorioTodosPedidos, Roles.RelatorioClientesPedidos,
    Roles.RelatorioEngajamento, 
    Roles.RelatorioOpsCs,
    Roles.RelatorioPlanoAcao,
    Roles.RelatorioClientesReunioes,
    Roles.RelatorioTodasReunioes,
    Roles.ReadResultsReport,
]

// Não existe flag de "admin" no sistema — a autorização é toda por código de
// permissão. Como proxy de "administrador da Mention" usamos quem administra os
// usuários da plataforma (LerUsuarios / CriarUsuarios / EditarUsuarios).
// Fica aqui (e não em authorize.directive.js) para não criar import circular:
// authorize.directive ↔ functions ↔ state/store já formam um ciclo.
export const isMentionAdmin = () => {
    const userRoles = store.getters['account/roles'] ?? []
    return userRoles.includes(Roles.LerUsuarios)
        || userRoles.includes(Roles.CriarUsuarios)
        || userRoles.includes(Roles.EditarUsuarios)
}

const addMenu = (rolesNecessarias, userRoles, menuList, menuItem) => {
    for (let index = 0; index < rolesNecessarias.length; index++) {
        const role = rolesNecessarias[index];
        if (userRoles.includes(role)) {
            menuList.push(menuItem)
            break;
        }
    }
    return menuList;
}

const translateMenuItems = (items) => items.map((item) => ({
    ...item,
    label: i18n.global.t(`utils.menu.${item.id}`),
    subItems: Array.isArray(item.subItems) ? translateMenuItems(item.subItems) : item.subItems,
}))

export const getMenu = () => {
    const userRoles = store.getters['account/roles']
    const isCliente = store.getters['account/isCliente']
    const isMention = store.getters['account/isMention']
    let menu = [
        {
            "id": "home",
            "label": "Home",
            "icon": "fa-solid fa-house",
            "link": "/",
            "routes": ["/"],
            "subItems": null
        }
    ]

    if (isCliente === true) {
        menu = addMenu([Roles.CriarMeusPedidos], userRoles, menu, {
            "id": "novo-pedido",
            "label": "Novo Pedido",
            "icon": "fa-solid fa-plus",
            "link": "/novo-pedido",
            "routes": ["/novo-pedido"],
            "subItems": null
        })
        // Clipping customers read orders (100) but cannot create them (102); for them the
        // order list is noise, so the item requires both.
        if (userRoles.includes(Roles.CriarMeusPedidos)) menu = addMenu([Roles.LerMeusPedidos], userRoles, menu, {
            "id": "meus-pedidos",
            "label": "Meus Pedidos",
            "icon": "fa-solid fa-clipboard-list",
            "link": "/meus-pedidos",
            "routes": ["/meus-pedidos"],
            "subItems": null
        })
        // Mesmo caso do plano de comunicação: a role é a mesma para todo cliente, quem separa
        // é o plano. Sem isto o cliente de plano sem sugestões veria no menu uma tela de um
        // produto que ele não contratou.
        if (exibeSugestoesConteudo()) menu = addMenu([Roles.LerMinhasSugestoes], userRoles, menu, {
            "id": "sugestoes-conteudo",
            "label": "Sugestões de Conteúdo",
            "icon": "fa-solid fa-lightbulb",
            "link": "/minhas-sugestoes",
            "routes": ["/minhas-sugestoes"],
            "subItems": null
        })
        menu = addMenu([Roles.ReadCustomerInterview], userRoles, menu, {
            "id": "entrevista",
            "label": "Entrevistas",
            "icon": "fa-solid fa-comment-dots",
            "link": "/entrevista",
            "routes": ["/entrevista"],
            "subItems": null
        })
        
        if (isCliente === true) {
            menu.push({
                "id": "atendimento-whatsapp",
                "label": "Atendimento",
                "icon": "fa-solid fa-headset",
                "link": "/atendimento",
                "routes": ["/atendimento"],
                "subItems": null
            })
        }

        menu = addMenu([Roles.RelatorioPublicacoes], userRoles, menu, {
            "id": "minhas-publicacoes",
            "label": "Minhas Publicações",
            "icon": "fa-solid fa-newspaper",
            "link": "/minhas-publicacoes",
            "routes": ["/minhas-publicacoes"],
            "subItems": null
        })
        menu = addMenu([Roles.RelatorioResultados], userRoles, menu, {
            "id": "relatorio-resultados",
            "label": "Relatório Resultados",
            "icon": "fa-solid fa-chart-mixed",
            "link": "/relatorio-resultados",
            "routes": ["/relatorio-resultados"],
            "subItems": null
        })
        // A role é a mesma para todo cliente; quem separa é o plano. Sem isto o cliente
        // self-service veria no menu uma tela de um produto que ele não contratou.
        if (exigePlanoComunicacao()) menu = addMenu([Roles.LerMeuPlanoComunicacao], userRoles, menu, {
            "id": "meu-plano-comunicacao",
            "label": "Plano de Comunicação",
            "icon": "fa-solid fa-bullhorn",
            "link": "/meu-plano-comunicacao",
            "routes": ["/meu-plano-comunicacao"],
            "subItems": null
        })
        menu = addMenu([Roles.LerMinhaEmpresa], userRoles, menu, {
            "id": "minha-conta",
            "label": "Minha Conta",
            "icon": "fa-solid fa-id-card",
            "link": "/minha-conta",
            "routes": ["/minha-conta"],
            "subItems": null
        })
        // US customers billed by Stripe: card, invoices and cancellation live in Stripe's portal.
        if (isStripeBilling()) menu = addMenu([Roles.LerMinhaEmpresa], userRoles, menu, {
            "id": "manage-billing",
            "label": "Manage billing",
            "icon": "fa-solid fa-credit-card",
            "type": "action",
            "action": openBillingPortal,
            "routes": [],
            "subItems": null
        })
        menu = addMenu([Roles.LerMeusUsuarios], userRoles, menu, {
            "id": "meus-usuarios",
            "label": "Usuários",
            "icon": "fa-solid fa-users",
            "link": "/meus-usuarios",
            "routes": ["/meus-usuarios"],
            "subItems": null
        })
        menu = addMenu([Roles.IsCliente], userRoles, menu, {
            "id": "minhas-indicacoes",
            "label": "Programa de Indicações",
            "icon": "fa-solid fa-gift",
            "link": "/beneficios",
            "routes": ["/beneficios"],
            "subItems": null
        })
    } else if (isMention === true) {
        // Grupo Clientes
        const clientesSubItems = [];
        
        if (userRoles.includes(Roles.LerTodosClientes) || userRoles.includes(Roles.LerMeusClientes)) {
            clientesSubItems.push({
                "id": "clientes",
                "label": "Clientes",
                "icon": "fa-solid fa-user",
                "link": "/clientes",
                "routes": ["/clientes"],
                "excludeRoutes": ["/clientes/entrevistas"]
            });
        }
        
        if (userRoles.includes(Roles.LerTodosClientes) || userRoles.includes(Roles.LerMeusClientes)) {
            clientesSubItems.push({
                "id": "gestao-clientes",
                "label": "Gestão de Clientes",
                "icon": "fa-solid fa-user-group",
                "link": "/gestao-clientes",
                "routes": ["/gestao-clientes"]
            });
        }
        
        if (userRoles.includes(Roles.LerUsuarios)) {
            clientesSubItems.push({
                "id": "usuarios",
                "label": "Usuários",
                "icon": "fa-solid fa-users",
                "link": "/usuarios",
                "routes": ["/usuarios"]
            });
        }

        if (userRoles.includes(Roles.LerTodosClientes) || userRoles.includes(Roles.LerMeusClientes)) {
            clientesSubItems.push({
                "id": "entrevistas",
                "label": "Entrevistas",
                "icon": "fa-solid fa-comment-dots",
                "link": "/clientes/entrevistas",
                "routes": ["/clientes/entrevistas"]
            });
        }
        
        if (clientesSubItems.length > 0) {
            menu.push({
                "id": "grupo-clientes",
                "label": "Clientes",
                "icon": "fa-solid fa-user-group",
                "subItems": clientesSubItems,
                "routes": ["/clientes", "/gestao-clientes", "/usuarios", "/clientes/entrevistas"]
            });
        }

        // Grupo Pedidos
        const pedidosSubItems = [];
        
        if (userRoles.includes(Roles.FazerPedidoTodos) || userRoles.includes(Roles.FazerPedidoClientes)) {
            pedidosSubItems.push({
                "id": "fazer-pedido",
                "label": "Fazer Pedido",
                "icon": "fa-solid fa-plus",
                "link": "/fazer-pedido",
                "routes": ["/fazer-pedido"]
            });
        }
        
        if (userRoles.includes(Roles.LerTodosPedidos) || userRoles.includes(Roles.LerClientesPedidos)) {
            pedidosSubItems.push({
                "id": "pedidos",
                "label": "Pedidos",
                "icon": "fa-solid fa-clipboard-list",
                "link": "/pedidos",
                "routes": ["/pedidos"]
            });
        }
        
        if (userRoles.includes(Roles.LerTodosSugestoesConteudo) || userRoles.includes(Roles.LerClientesSugestoesConteudo)) {
            pedidosSubItems.push({
                "id": "sugestoes-conteudo",
                "label": "Sugestões de Conteúdo",
                "icon": "fa-solid fa-lightbulb",
                "link": "/sugestoes-conteudo",
                "routes": ["/sugestoes-conteudo"]
            });
        }
        
        if (pedidosSubItems.length > 0) {
            menu.push({
                "id": "grupo-pedidos",
                "label": "Pedidos",
                "icon": "fa-solid fa-clipboard-list",
                "subItems": pedidosSubItems,
                "routes": ["/fazer-pedido", "/pedidos", "/sugestoes-conteudo"]
            });
        }

        // Menu "Clipping" (mantém separado)
        menu = addMenu([Roles.Clipping], userRoles, menu, {
            "id": "clipping",
            "label": "Clipping",
            "icon": "fa-solid fa-paperclip",
            "link": "/clipping",
            "routes": ["/clipping"],
            "subItems": null
        });

        // Menu "Press" (mantém separado)
        menu = addMenu([Roles.Clipping], userRoles, menu, {
            "id": "press",
            "label": "Press",
            "icon": "fa-solid fa-newspaper",
            "link": "/press",
            "routes": ["/press"],
            "subItems": null
        });

        // Menu "Controle de Negociações" (mantém separado) - COMENTADO TEMPORARIAMENTE
        // menu = addMenu([Roles.LerTodosPedidos, Roles.LerClientesPedidos], userRoles, menu, {
        //     "id": "controle-negociacoes",
        //     "label": "Controle de Negociações",
        //     "icon": "fa-solid fa-handshake",
        //     "link": "/controle-negociacoes",
        //     "routes": ["/controle-negociacoes"],
        //     "subItems": null
        // });

        // Menu "Relatórios" (mantém como está)
        menu = addMenu(RolesDisplayRelatorios, userRoles, menu, {
            "id": "relatorios",
            "label": "Relatórios",
            "icon": "fa-solid fa-chart-mixed",
            "link": "/relatorios",
            "routes": [
                "/relatorios", 
                "/relatorio-publicacoes",
                "/relatorio-pedidos",
                "/relatorio-engajamento",
                "/relatorio-opscs",
                "/relatorio-plano-acao",
                "/relatorio-pesquisa-satisfacao",
                "/relatorio-reunioes",
                "/relatorio-resultados-mention"
            ],
            "subItems": null
        });

        // Grupo Comercial — módulo com permissões próprias (600–609, backend #1653).
        // O umbrella CommercialModuleAccess (600) libera o grupo; as finas, cada sub-item.
        const comercialSubItems = [];

        if (userRoles.includes(Roles.CommercialModuleAccess)) {
            if (userRoles.includes(Roles.CommercialContactForm)) {
                comercialSubItems.push({
                    "id": "formulario-contatos",
                    "label": "Formulário de Contatos",
                    "icon": "fa-solid fa-comments",
                    "link": "/formulario-contatos",
                    "routes": ["/formulario-contatos"]
                });
            }

            if (userRoles.includes(Roles.CommercialReferrals)) {
                comercialSubItems.push({
                    "id": "beneficios",
                    "label": "Programa de Indicações",
                    "icon": "fa-solid fa-gift",
                    "link": "/beneficios-indicacoes",
                    "routes": ["/beneficios-indicacoes"]
                });
            }

            if (userRoles.includes(Roles.CommercialProspectClipping)) {
                comercialSubItems.push({
                    "id": "clipping-prospect",
                    "label": "Clipping para prospect",
                    "icon": "fa-solid fa-earth-americas",
                    "link": "/clipping-prospect",
                    "routes": ["/clipping-prospect"]
                });
            }

            if (userRoles.includes(Roles.CommercialSelfServiceLeads)) {
                comercialSubItems.push({
                    "id": "leads-self-service",
                    "label": "Leads do self-service",
                    "icon": "fa-solid fa-user-magnifying-glass",
                    "link": "/leads-self-service",
                    "routes": ["/leads-self-service"]
                });
            }

            if (userRoles.includes(Roles.CommercialPreRegistration)) {
                comercialSubItems.push({
                    "id": "pre-cadastro",
                    "label": "Pré Cadastro",
                    "icon": "fa-solid fa-user-plus",
                    "link": "/pre-cadastro",
                    "routes": ["/pre-cadastro"]
                });
            }
        }

        if (comercialSubItems.length > 0) {
            menu.push({
                "id": "grupo-comercial",
                "label": "Comercial",
                "icon": "fa-solid fa-briefcase",
                "subItems": comercialSubItems,
                "routes": ["/formulario-contatos", "/beneficios-indicacoes", "/clipping-prospect", "/pre-cadastro", "/leads-self-service"]
            });
        }

        // Grupo Configurações
        const configuracoesSubItems = [];
        
        if (userRoles.includes(Roles.VisualizarLinks)) {
            configuracoesSubItems.push({
                "id": "repositorio-links",
                "label": "Repositório de links",
                "icon": "fa-solid fa-link",
                "link": "/repositorio-links",
                "routes": ["/repositorio-links"]
            });
        }
        
        if (userRoles.includes(Roles.Segmentos)) {
            configuracoesSubItems.push({
                "id": "segmentos",
                "label": "Segmentos",
                "icon": "fa-solid fa-grid-2",
                "link": "/segmentos",
                "routes": ["/segmentos"]
            });
        }
        
        if (userRoles.includes(Roles.TermosUso)) {
            configuracoesSubItems.push({
                "id": "termos-uso",
                "label": "Termos de Uso",
                "icon": "fa-solid fa-lock",
                "link": "/termos-uso",
                "routes": ["/termos-uso"]
            });
        }
        
        if (userRoles.includes(Roles.TemplateEmails)) {
            configuracoesSubItems.push({
                "id": "templates-notificacoes",
                "label": "Gerenciar Notificações",
                "icon": "fa-solid fa-gear",
                "link": "/templates-notificacoes",
                "routes": ["/templates-notificacoes"]
            });
        }
        
        if (userRoles.includes(Roles.EnvioEmails)) {
            configuracoesSubItems.push({
                "id": "envio-emails",
                "label": "Envio de e-mails",
                "icon": "fa-solid fa-envelope",
                "link": "/envio-emails",
                "routes": ["/envio-emails"]
            });
        }
        
        if (userRoles.includes(Roles.AcessarCalendarioFeriados)) {
            configuracoesSubItems.push({
                "id": "calendario-feriados",
                "label": "Calendário de feriados",
                "icon": "fa-solid fa-calendar-days",
                "link": "/calendario-feriados",
                "routes": ["/calendario-feriados"]
            });
        }
        
        if (userRoles.includes(Roles.VeiculosGerenciar)) {
            configuracoesSubItems.push({
                "id": "veiculos",
                "label": "Veículos",
                "icon": "fa-solid fa-newspaper",
                "link": "/veiculos",
                "routes": ["/veiculos"]
            });
        }
        
        configuracoesSubItems.push({
            "id": "jornalistas",
            "label": "Jornalistas",
            "icon": "fa-solid fa-user-magnifying-glass",
            "link": "/jornalistas",
            "routes": ["/jornalistas"]
        });
        
        if (userRoles.includes(Roles.GerenciarArquivosFineTuning)) {
            configuracoesSubItems.push({
                "id": "fine-tuning-arquivos",
                "label": "Arquivos Fine-tuning",
                "icon": "fa-solid fa-robot",
                "link": "/fine-tuning-arquivos",
                "routes": ["/fine-tuning-arquivos"]
            });
        }

        if (userRoles.includes(Roles.SourceSegments)) {
            configuracoesSubItems.push({
                "id": "segmentos-veiculo",
                "label": "Segmentos de veículo",
                "icon": "fa-solid fa-grid-2",
                "link": "/segmentos-veiculo",
                "routes": ["/segmentos-veiculo"]
            });
        }

        if (configuracoesSubItems.length > 0) {
            menu.push({
                "id": "grupo-configuracoes",
                "label": "Configurações",
                "icon": "fa-solid fa-gear",
                "subItems": configuracoesSubItems,
                "routes": [
                    "/repositorio-links",
                    "/segmentos",
                    "/termos-uso",
                    "/templates-notificacoes",
                    "/envio-emails",
                    "/calendario-feriados",
                    "/veiculos",
                    "/jornalistas",
                    "/fine-tuning-arquivos",
                    "/segmentos-veiculo"
                ]
            });
        }
    }

    return translateMenuItems(menu);
}

export default Roles;
